/**
 * Classe abstrata do menu
 * para os grids.
 * @author: adalto.junior
 * Date: 15/10/13
 * Time: 14:37
 */


Greenmile.Grid = Greenmile.Grid || {};

Greenmile.Grid.Menu = function () {

    this.gridMenu = null;

    this.optionsMenu = {};
    this.model = {};

    var enabledMenu = [];

    enabledMenu.isEnabled = function (name) {

        if (this.indexOf(name) !== -1) {

            return true;

        }

        return false;

    };

    /**
     *
     * @param menus array
     */

    this.setEnabledMenus = function (menus) {

        if (menus) {

            for (var i = 0; i < menus.length; i++) {

                if (enabledMenu.indexOf(menus[i]) === -1) {

                    enabledMenu.push(menus[i]);

                }
            }

        }

    };

    this.getEnabledMenu = function () {
        return enabledMenu;
    };

    this.setOptionsMenu = function (options) {

        if (options) {
            this.optionsMenu = options;
        }

    };

    this.showMenuToRowSelected = function (event, args) {

        var error           = null,
            optionsMenuList = null;

        try {

            var columns = args.grid.getColumns();

            var column = columns[args.cell];

            if (column && column.id !== 'edit' && column.id !== 'checkBoxColumn') {

                event.preventDefault();

                this.model = args.grid.getDataItem(args.row).model;

                this.gridMenu = new Monet.UI.FloatMenu(null, this.optionsMenu);
                optionsMenuList = new Monet.UI.List();

                optionsMenuList.itemRenderer = Monet.UI.ContentMenuItem;

                const renderMenu = function () {
                  this.gridMenu.menuItems = this.getItemsToMenu(this.model);
                  this.gridMenu.removeAllMenus();

                  if (this.gridMenu.menuItems.length) {
                    this.gridMenu.create(event, this.gridMenu);
                    event.stopPropagation();
                  }
                }.bind(this);

                this.gridMenu.listProvider = optionsMenuList;
                if (this.beforeRenderMenu) {
                  this.beforeRenderMenu(renderMenu);
                } else {
                  renderMenu();
                }

            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                'Error on show menu to row selected.', e);
            error.console();
        }

    };

};